"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lite_1 = require("firebase/firestore/lite");
const constants_1 = require("../../utils/constants");
const getDailyStatId_1 = __importDefault(require("../../utils/getDailyStatId"));
const getAllTimesStatsId_1 = __importDefault(require("../../utils/getAllTimesStatsId"));
class FirestoreStats {
    constructor(store) {
        this.store = store;
    }
    setDoc(stats) {
        return __awaiter(this, void 0, void 0, function* () {
            const ref = (0, lite_1.doc)((0, lite_1.collection)(this.store, constants_1.Collections.STATS), stats.id);
            yield (0, lite_1.setDoc)(ref, stats);
        });
    }
    getDoc(id, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield (0, lite_1.getDoc)((0, lite_1.doc)(this.store, constants_1.Collections.STATS, id));
            if (!result.exists()) {
                return {
                    id: id,
                    type: type,
                    createdAt: new Date().toISOString(),
                    value: 0,
                };
            }
            return result.data();
        });
    }
    getDailyStats(ownerId, statName) {
        return __awaiter(this, void 0, void 0, function* () {
            const id = (0, getDailyStatId_1.default)(ownerId, statName);
            return yield this.getDoc(id, 'daily');
        });
    }
    getAllTimeStats(ownerId, statName) {
        return __awaiter(this, void 0, void 0, function* () {
            const id = (0, getAllTimesStatsId_1.default)(ownerId, statName);
            return yield this.getDoc(id, 'all-time');
        });
    }
}
exports.default = FirestoreStats;
